import * as Yup from 'yup'
import { IChangeLogRoleContent } from 'typescript/interfaces/changeLog'

const stripHtml = (html: string) => html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim()

export const hasContent = (html: string) => Boolean(html) && (stripHtml(html).length > 0 || html.toLowerCase().includes('<img'))

export const changeLogFormSchema = Yup.object().shape({
  name: Yup.string().trim().required('Name is required'),
  releaseDate: Yup.string().nullable().required('Release date is required'),
  roleContents: Yup.array()
    .test('at-least-one-enabled', 'At least one role section must be turned on', (value) =>
      Boolean(value && (value as Array<IChangeLogRoleContent>).some((content) => content.isEnabled))
    )
    .test('enabled-sections-have-content', 'Every role section that is turned on must have content', (value) =>
      Boolean(
        value &&
          (value as Array<IChangeLogRoleContent>).filter((content) => content.isEnabled).every((content) => hasContent(content.bodyHtml))
      )
    ),
})
